// ─── SUI Providers Wrapper ───────────────────────────────────────────────
// Wraps the app with SuiClientProvider + WalletProvider + QueryClientProvider
import React from 'react';
import { SuiClientProvider, WalletProvider, createNetworkConfig } from '@mysten/dapp-kit';
import { JsonRpcHTTPTransport } from '@mysten/sui/jsonRpc';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import '@mysten/dapp-kit/dist/index.css';

const { networkConfig } = createNetworkConfig({
  testnet: {
    network: 'testnet',
    transport: new JsonRpcHTTPTransport({ url: 'https://fullnode.testnet.sui.io:443' }),
  },
  mainnet: {
    network: 'mainnet',
    transport: new JsonRpcHTTPTransport({ url: 'https://fullnode.mainnet.sui.io:443' }),
  },
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

interface SuiProviderProps {
  children: React.ReactNode;
}

export default function SuiProvider({ children }: SuiProviderProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <SuiClientProvider networks={networkConfig} defaultNetwork="testnet">
        <WalletProvider autoConnect>
          {children}
        </WalletProvider>
      </SuiClientProvider>
    </QueryClientProvider>
  );
}
